{
  "name": "@ns/company-ch-validation",
  "version": "1.1.0",
  "description": "Validate your company using companies house",
  "inputs": {},
  "outcomes": {
    "complete": {}
  },
  "publicLedger": [
    {
      "id": "validation-message",
      "outcome": "complete",
      "kind": "INTERNAL_MESSAGE"
    }
  ]
}
